import { Header, Main } from '@pcrm/fe/ui-kit';
import { createFileRoute } from '@tanstack/react-router';
import { PartnersScreen } from '../../../features/partners/partners-screen';

/**
 * „Conta → Parteneri", anunțat în meniu de la #110, construit la #114.
 *
 * `Header` și `Main` stau **în pagină**, nu într-un layout de zonă: Conta are azi un
 * singur ecran, iar un layout pentru unul singur ar fi un fișier care nu economisește
 * nimic. Când zona crește, se face cum s-a făcut la `/clienti` și `/setari`.
 *
 * `/conta` nu e rută: meniul duce direct la ecran, iar o pagină-index care doar ar trimite
 * mai departe n-ar avea ce spune.
 */
export const Route = createFileRoute('/_authenticated/conta/parteneri')({
  component: ParteneriPagina,
});

function ParteneriPagina() {
  return (
    <>
      <Header fixed>
        <h1 className="text-lg font-semibold">Conta</h1>
      </Header>

      <Main className="flex flex-1 flex-col gap-4 sm:gap-6">
        <PartnersScreen />
      </Main>
    </>
  );
}
